import { DropDownCategories } from 'src/types/generic';

export const ProductFilterCategories: DropDownCategories[] = [
  { value: 0, label: 'All Items' },
  { value: 1, label: 'Only Contracted Items' },
];
